import { render, staticRenderFns } from "./PayTab.vue?vue&type=template&id=23763253&scoped=true&"
import script from "./PayTab.vue?vue&type=script&lang=js&"
export * from "./PayTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23763253",
  null
  
)

export default component.exports